import { url } from './urls';

export const buttons = {
  grayButtonWave: `${url.CDN_URL}/assets/buttons/gray-button-wave.png`,
  greenButtonWave: `${url.CDN_URL}/assets/buttons/green-button-wave.png`,
  yellowButtonWave: `${url.CDN_URL}/assets/buttons/yellow-button-wave.png`,
  toggleBlue: `${url.CDN_URL}/buttons/toggle-blue.png`,
  toggleRed: `${url.CDN_URL}/buttons/red-toggle.png`,
  toggleGray: `${url.CDN_URL}/buttons/toggle-gray.png`,
  checkIcon: `${url.CDN_URL}/buttons/check-toggle-icon.png`,
};

export const icons = {
  dashboard: `${url.CDN_URL}/icons/dashboard.svg`,
  account: `${url.CDN_URL}/icons/account.svg`,
  arrowLeft: `${url.CDN_URL}/icons/arrow-left.svg`,
  discord: `${url.CDN_URL}/icons/discord.svg`,
  fabLogo: `${url.CDN_URL}/icons/fab-logo.svg`,
  loader: `${url.CDN_URL}/icons/loader.svg`,
  nameLogo: `${url.CDN_URL}/icons/name-logo.svg`,
  twitter: `${url.CDN_URL}/icons/twitter.svg`,
  powerIcon:
    'https://mint-exp.s3.eu-central-1.amazonaws.com/fab/assets/general/icons/power-icon.webp',
};

export const general = {
  accountIconWhite: `${url.CDN_URL}/general/account-icon-white.png`,
  appStore: `${url.CDN_URL}/general/app-store.png`,
  arrowDown: `${url.CDN_URL}/general/arrow-down.png`,
  backgroundGradient: `${url.CDN_URL}/general/background-gradient.png`,
  background: `${url.CDN_URL}/general/background.png`,
  bonusFlag: `${url.CDN_URL}/general/bonus-flag.png`,
  currencyBarrel: `${url.CDN_URL}/general/currency-barrel.png`,
  fabLogoWhite: `${url.CDN_URL}/general/fab-logo-white.svg`,
  fabLogo: `${url.CDN_URL}/general/fab-logo.png`,
  nameLogoWhite: `${url.CDN_URL}/general/name-logo-white.svg`,
  noOfferBox: `${url.CDN_URL}/general/no-offer-box.png`,
  playMarket: `${url.CDN_URL}/general/play-market.png`,
  vector: `${url.CDN_URL}/general/vector.png`,
  webshopOrderBackground: `${url.CDN_URL}/general/Webshop_Background_order.png`,
  pictoiconHourglass: `${url.CDN_URL}/general/pictoicon-hourglass.png`,
  userIcon: `${url.CDN_URL}/icons/profile-icon.png
`,

};

export const flags = {
  enFlag: 'https://mint-exp.s3.eu-central-1.amazonaws.com/fab/assets/general/icons/en-language-icon.png',
  koFlag: 'https://mint-exp.s3.eu-central-1.amazonaws.com/fab/assets/general/icons/ko-language-icon.png',
};